<template>
	<div class="content">
		<div class="row animated fadeIn">
			<div class="col-12">
				<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true" />
				<div class="card" v-if="asyncDone === false">
					<!-- Show the loader when async operation is going on -->
					<div class="loader"></div>
				</div>
			</div>
			<div class="col-12" v-if="asyncDone">
				<div class="card">
					<div class="card-header mt-3">
						<h4 class="card-title ml-4">Open New Support Ticket</h4>
					</div>
					<div class="card-body pl-5 pr-5 mb-4">
						<form @submit.prevent="createTicket">
							<div class="form-group">
								<label for="emailSub">Subject <strong class="text-danger">*</strong></label>
								<input type="text" class="form-control" id="emailSub" aria-describedby="emailSub" required v-model.trim="subject">
							</div>
							<div class="form-group">
								<label for="domainSub">Select Domain <strong class="text-danger">*</strong></label>
								<select  class="form-control" id="domainSub" aria-describedby="domainSub" required v-model="selectedDomain">
									<optgroup v-for="(account, index) in accounts" :key="account.primary.domain + '_' + index" :label="account.primary.domain">
										<option :value="account.primary.domain">{{account.primary.domain}}</option>
										<option v-if="account.primary.staging && account.primary.staging.enabled" :value="account.primary.staging.domain">{{account.primary.staging.domain}}</option>
										<template v-for="(addon,addonindex) in account.addon">
											<option :value="addon.domain" :key="addon.domain + '_' + addonindex">{{addon.domain}}</option>
											<option v-if="addon.staging && addon.staging.enabled" :value="addon.staging.domain" :key="addon.staging.domain + '_' + addonindex">{{addon.staging.domain}}</option>
										</template>
									</optgroup>
								</select>
							</div>
							<div class="form-group">
								<label for="ticketBody">Message <strong class="text-danger">*</strong></label>
								<textarea class="form-control" id="ticketBody" rows="7" v-model.trim="message"></textarea>
							</div>
							<button type="submit" class="btn btn-primary btn-lg w-100"><i class="fa fa-paper-plane" aria-hidden="true"></i> Submit Ticket</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import swal from 'sweetalert2';
import { functions } from '@/firebase/init';
import AES from 'crypto-js/aes'

export default {
	name: "openNewSupportTicket",
	components: {
	Alert: () =>
	import(/* webpackChunkName: "alert" */ "../../../../components/Alerts.vue")
	},
	data() {
		return {
			subject: '',
			message: '',
			selectedDomain: ''
		}
	},
  computed: {
		clientID() {
			return this.$store.getters.getCustomerID
		},
		asyncDone() {
			return this.$store.getters["async/state"];
		},
		alertType() {
			return this.$store.getters["alert/type"];
		},
		alertMessage() {
			return this.$store.getters["alert/message"];
		},
		alertShow() {
			return this.$store.getters["alert/show"];
		},
		accounts() {
			return this.$store.getters['hosting/accounts'];
		},
		aesSecret() {
			return this.$store.getters["crypto/aesSecret"];
		},
	},
	methods: {
		encryptIndex(index) {
			return AES.encrypt(index, this.aesSecret).toString()
		},
		createTicket() {
			if(this.subject === '' || this.message === '' || this.selectedDomain === '') {
				swal({
					title: "All fields required!",
					text: "Please fill all the fields as all fields are required.",
					type: "error",
					confirmButtonText: "Try Again",
					confirmButtonColor: "#EE8057"
				})
			} else {
				this.$store.dispatch("async/stateUpdate", { state: false })

				const openNewTicket = functions.httpsCallable("openNewTicket")
				openNewTicket({
					clientID: this.clientID,
					subject: 'WPO : ' + this.subject + ' :: ' + this.selectedDomain,
					message: this.message
				})
				.then(async response => {
				  if (this.$route.params.fromSendReport) {
            try {
              await this.$http.post('host-bill/update-ticket-note', {
                ticketId: response.data.ticket_id,
                notes: '"Send Feedback / Bug Report" in WPO option was used to open this ticket.',
                grant_type: 'token'
              });
            } catch (e) {
              console.log(e.toString())
            }
          }
          this.addLog({
            primaryPlan: 'Account Based Operation',
            message: 'New Ticket has been opened, Domain: ' + this.selectedDomain,
            level: "success"
          })
					this.$store.dispatch("async/stateUpdate", { state: true })

					if(response.data.success) {
						this.$router.push({ name: 'viewTicket', params: { id: this.encryptIndex( response.data.ticket_id.toString() ) } });
						// swal({
						// 	title: "Ticket Created Successfully!",
						// 	text: response.data.message,
						// 	type: "success",
						// 	confirmButtonText: "Go to Ticket Archive Page",
						// 	confirmButtonColor: "#6ACF98"
						// })
						// .then(result => {
						// 	if(result.value) {
						// 		this.$router.push({ name: 'ticketsArchive' })
						// 	}
						// })
					} else {
						swal({
							title: "Something went Wrong!",
							text: response.data.message,
							type: "error",
							confirmButtonText: "Try Again",
							confirmButtonColor: "#EE8057"
						})
            this.addLog({
              message: "Error: Open Ticket, Domain " + this.selectedDomain,
              level:  "error"
            })
					}
				})
				.catch(err => {
					this.$store.dispatch("async/stateUpdate", { state: true })

					swal({
						title: "Something went Wrong!",
						text: err.message,
						type: "error",
						confirmButtonText: "Try Again",
						confirmButtonColor: "#EE8057"
					})
					this.addLog({
						message: "Error: Open Ticket, Message:" + err.message,
						level:  "error"
					})
				})
			}
		}
	}
}
</script>
